import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    CustomerProfileResponse, 
    CustomerProfileUpdate, 
    PasswordUpdate
} from '../../_models/profile/customer-profile.model';
import { ApiResponse } from '../../_models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerProfileService {
    private customerProfileUrl = `${environment.apiUrl}/customer/profile`;

    constructor(private http: HttpClient) { }

    getCustomerProfile(): Observable<ApiResponse<CustomerProfileResponse>> {
        return this.http.get<ApiResponse<CustomerProfileResponse>>(this.customerProfileUrl);
    }

    updateCustomerProfile(
        profileUpdate: CustomerProfileUpdate, 
        imageFile?: File
    ): Observable<ApiResponse<CustomerProfileResponse>> {
        const formData = new FormData();
        formData.append('profile', new Blob([JSON.stringify(profileUpdate)], {
            type: 'application/json'
        }));
        
        if (imageFile) {
            formData.append('image', imageFile);
        }

        return this.http.put<ApiResponse<CustomerProfileResponse>>(
            this.customerProfileUrl, 
            formData
        );
    }

    updateCustomerProfileImage(imageFile: File): Observable<ApiResponse<CustomerProfileResponse>> {
        const formData = new FormData();
        formData.append('image', imageFile);

        return this.http.put<ApiResponse<CustomerProfileResponse>>(
            `${this.customerProfileUrl}/image`, 
            formData
        );
    }

    deleteCustomerProfileImage(): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`${this.customerProfileUrl}/image`);
    }

    updateCustomerPassword(passwordUpdate: PasswordUpdate): Observable<ApiResponse<void>> {
        return this.http.put<ApiResponse<void>>(
            `${this.customerProfileUrl}/password`, 
            passwordUpdate
        );
    }
}